import React, { useEffect, useState } from 'react';
import { format, isValid } from 'date-fns';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import AbiActivityLogApiUrls from '../../../apiUrls/AbiActivityLogApiUrls';

const LabelValue = ({ label, value }) => (
  <Grid item xs={12} sm={6}>
    <Typography variant="caption" color="text.secondary" display="block">
      {label}
    </Typography>
    <Typography variant="body2">{value ?? '-'}</Typography>
  </Grid>
);

const ActivityLogDetailDialog = ({ open, id, onClose }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !id) return;
    setLoading(true);
    setData(null);
    fetch(`${AbiActivityLogApiUrls.GET_BY_ID}/${id}`, {
      headers: {
        Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('userToken')),
      },
    })
      .then((res) => res.json())
      .then((json) => setData(json.data ?? json))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [open, id]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Activity Log Detail</Typography>
          <IconButton size="small" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} width={16} />
          </IconButton>
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress size={32} />
          </Box>
        ) : data ? (
          <Grid container spacing={2} pt={1}>
            <LabelValue label="ID" value={data.id} />
            <LabelValue label="Party ID" value={data.partyId} />
            <LabelValue label="User ID" value={data.userId} />
            <LabelValue label="Username" value={data.username} />
            <LabelValue label="Action" value={data.action} />
            <LabelValue label="Resource Type" value={data.resourceType} />
            <LabelValue label="Resource ID" value={data.resourceId} />
            <LabelValue label="Resource Name" value={data.resourceName} />
            <Grid item xs={12}>
              <Typography variant="caption" color="text.secondary" display="block">
                Description
              </Typography>
              <Typography variant="body2">{data.description ?? '-'}</Typography>
            </Grid>
            <LabelValue label="Created Date" value={(() => { const d = new Date(data.createdDate); return data.createdDate && isValid(d) ? format(d, 'dd MMM yyyy, HH:mm:ss') : (data.createdDate ?? '-'); })()} />
          </Grid>
        ) : (
          <Typography variant="body2" color="text.secondary">
            No data found.
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ActivityLogDetailDialog;
